import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import memoize from 'memoize-one'
import { connect } from 'react-redux'
import { compose } from '../../../common/helpers'
import copy from 'copy-to-clipboard'

import { withTranslation } from 'react-i18next'
import { fields } from '../../../common/lib/redux-fields'
import { withNotifs } from '../hoc'
import {
  Box,
  Row,
  Col,
  Button,
  LinkButton,
  CreateOrderButtonsWrapper,
  Gap,
  FieldError,
  WarningMessage,
  T,
} from '..'
import {
  LensTypeSection,
  IndividualSection,
  NoteSection,
  ReferenceField,
  OrderTypeField,
} from '../order'
import { orderTypes, R, L, appTypeConfig } from '../../../common/config'
import {
  fetchLensSelectList,
  fetchCatalogExtensions,
  fetchFrameBrands,
  setShouldUpdateLensesList,
  clearCurrentLens,
  setCanSelectStockLens,
  validateLensParams,
  fetchLens,
} from '../../../common/catalog/actions'
import {
  clearLensFieldsValues,
  getOrderFormWarnings,
  isSphOrCylFieldInHundredths,
} from '../../app/helpers'
import { getLensFieldsValuesBySide } from '../../../common/helpers'
import {
  getConstants,
  getFormKeys,
  noStockParams,
  fieldsConfig,
} from '../../../common/schemaConfig'
import { enableOrderStep } from '../../../common/orders/actions'
import { fetchWorkers } from '../../../common/app/actions'
import { TextField, CheckboxField, SwitchField, LensParamsField, SelectField } from '../fields'
import FrameTypeBox from '../order/FrameTypeBox'
import InfoMessage from '../InfoMessage'
import { processErrorsAndShowNotifs } from '../../helpers'
import { selectVca } from '../../../common/vca/actions'
import { notifyWarning } from '../../bugsnag'
import withRouter from '../hoc/withRouter'
import { PopTooltip } from '../Tooltip'
import Icon from '../Icon'

// import './Form.scss'
const SelectRightWrapper = styled(Row)``

const SelectLeftWrapper = styled(Row)`
  padding-bottom: 3rem;
`

const SelectRL = styled.div`
  position: relative;
  left: -0.4rem;
  top: 7.3rem;
  margin-left: -3.2rem;
`

const showDecentration = orderType =>
  appTypeConfig.isDecentrationEnabled && orderType === orderTypes.DIAMETER_ONLY

const showCentration = values => {
  if (appTypeConfig.isEdgingWithoutShapeEnabled && values?.isEdgingWithoutShape) return true
  return values?.orderType !== orderTypes.DIAMETER_ONLY 
}

const showMinimalThickness = orderType => orderType === orderTypes.DIAMETER_ONLY

const lensFields = getConstants()

// TODO sjednotit tyto funkce někam do helpers
// použít funkci z app/helpers
const getBothLensFields = (fields, fieldName) => ({
  r: fields[`${fieldName}R`],
  l: fields[`${fieldName}L`],
})

// TODO: nakonci kroku 1 je potřeba zvalidovat, že nezůstanou nastaveny nesmyslné fieldy
// například vybraná levá čočka když zaškrtnu, že levá čočka není...
class OrderStep1Form extends Component {
  revalidateTimeoutId = null

  componentDidMount() {
    const {
      setCanSelectStockLens,
      fetchWorkers,
      fetchCatalogExtensions,
      fetchFrameBrands,
      fields,
    } = this.props
    setCanSelectStockLens(this.getCanSelectStockLens(R), R)
    setCanSelectStockLens(this.getCanSelectStockLens(L), L)
    fetchWorkers()
    fetchFrameBrands()

    const initExtensions = async () => {
      const catalogExtensions = await fetchCatalogExtensions().meta.action.payload
      fields.$setValidationOptions({ catalogExtensions: catalogExtensions?.data })
    }

    initExtensions()
  }

  componentWillUnmount() {
    clearTimeout(this.revalidateTimeoutId)
  }

  // it would be good to preload data, but it shows loading bar in lens select after order is loaded
  // it should be moved to CreateOrderPage
  // componentDidUpdate(prevProps) {
  //   const prevIsLoading = prevProps.isLoading
  //   const { isLoading } = this.props
  //   if (isLoading === false && prevIsLoading === true) {
  //     // this.fetchLensesActions()
  //   }
  // }

  onLensPropsChange = async (side, affectsLensList) => {
    const {
      clearCurrentLens,
      setShouldUpdateLensesList,
      fields,
      validateLensParams,
      setCanSelectStockLens,
      canSelectStockLensR,
      canSelectStockLensL,
      notifs,
      t,
      fetchLens,
    } = this.props
    const canSelectStockLens = side === L ? canSelectStockLensL : canSelectStockLensR
    const newCanSelectStockLens = this.getCanSelectStockLens(side)
    const canSelectStockLensChanged = canSelectStockLens !== newCanSelectStockLens
    if (canSelectStockLensChanged) setCanSelectStockLens(newCanSelectStockLens, side)

    if (!canSelectStockLensChanged && !affectsLensList) return
    setShouldUpdateLensesList(true, side)

    // TODO - během validace zablokovat možnost přesunu do jiného kroku

    const lensFieldsValues = getLensFieldsValuesBySide(fields)
    const orderType = fields.orderType.value
    const values = side === R ? lensFieldsValues.r : lensFieldsValues.l
    const { lens } = values
    if (!lens) return
    const validationResult = await validateLensParams({
      id: lens,
      customQuery: { ...values, orderType },
      side,
      fieldValues: fields.$values(),
    }).meta.action.payload

    if (validationResult.data.result) {
      /* pokud se nezmění čočka, může se ještě rozšířit pole průměrů.
      Proto je potřeba stáhnout čočku znovu. Pokud už je vybraná. */
      fetchLens(lens, side, values)
      return
    }

    clearLensFieldsValues({ fields, side })
    clearCurrentLens(side)

    if (fields.isLeftLensSameAsRight.value && side === L && fields.lensR.value) {
      notifs.warning({
        title: t('Selected lens is not available for left eye!'),
      })

      if (appTypeConfig.areBothLensesAlwaysSame) {
        clearLensFieldsValues({ fields, side: R })
        clearCurrentLens(R)
        clearLensFieldsValues({ fields, side: L })
        clearCurrentLens(L)
      } else {
        fields.isLeftLensSameAsRight.onChange({ value: false })
      }

    }
  }

  getCanSelectStockLens = side => {
    const { fields } = this.props
    const values = fields.$values()
    const isStockLensDisabled = Object.keys(values).some(key => {
      if (!values[key] && values[key] !== 0) return false
      return noStockParams.some(p => `${p}${side}` === key)
    })
    return !isStockLensDisabled
  }

  validateNextSteps = () => {
    const { enableOrderStep, fields } = this.props
    const values = fields.$values()

    // TODO: validation here

    // just example
    const condition = !!values.sphereR && !!values.sphereL
    const conditionSummary = condition && values.orderType === orderTypes.DIAMETER_ONLY
    // TODO: jak vyresit validaci z kroku 2? pokud se napr. vratim ze 3 zpet do 1 a upravim neco
    // co neovlivni tvar -- tvar je validni a tedy to nechci zakazat...  pouziti static u step2?
    // nebo to mit vytazeny ven? pouzit validator i na ne-fields pole?

    enableOrderStep({ shape: condition, summary: conditionSummary })
  }

  validateFieldsAndRedirect = link => {
    const { history, fields, validatingParamsL, validatingParamsR } = this.props
    const errors = fields.$validate({ step: 1 })
    if (errors.length === 0) {
      // pokud probíhá validace parametrů čočky na serveru, tak zkusit znova později
      if (validatingParamsL || validatingParamsR) {
        // todo show some info to customer. Do same for upper navigation. Refactor
        this.revalidateTimeoutId = setTimeout(() => this.validateFieldsAndRedirect(link), 500)
        return
      }
      history.push(link)
    } else {
      processErrorsAndShowNotifs(errors, 1)
    }
  }

  fetchLensesActions = () => {
    const {
      fields,
      shouldUpdateLensesListR,
      shouldUpdateLensesListL,
      setShouldUpdateLensesList,
      fetchLensSelectList,
    } = this.props
    const lensesFieldsValues = getLensFieldsValuesBySide(fields)
    if (shouldUpdateLensesListR && fields.rightLensEnabled.value) {
      setShouldUpdateLensesList(false, R)
      fetchLensSelectList(lensesFieldsValues.r, R, fields.$values())
    }
    if (shouldUpdateLensesListL && fields.leftLensEnabled.value) {
      setShouldUpdateLensesList(false, L)
      fetchLensSelectList(lensesFieldsValues.l, L, fields.$values())
    }
  }

  fetchLensesActionsNextFrame = () => requestAnimationFrame(this.fetchLensesActions)

  getIsIndividualMenuAvailable = () => {
    const { fields, lensR, lensL } = this.props
    const fieldsValues = fields.$values()
    const menuConfigList = appTypeConfig.individualMenus

    // check if at least one lens is selected and has individual menu
    if (
      (fieldsValues?.lensR && lensR?.individualMenu) ||
      (fieldsValues?.lensL && lensL?.individualMenu)
    ) {
      // check if the individual menu exists in the config
      const menuConf = menuConfigList[fieldsValues.individualMenu]
      if (menuConf) return true
    }

    return false
  }

  clearFrameOrShape = e => {
    const nextType = e.value
    // const isShapePreferred = [
    //   orderTypes.WITH_SHAPE, orderTypes.EDGING, orderTypes.EDGING_COMPLETION,
    // ].includes(currentType)
    const willBeShape = [
      orderTypes.WITH_SHAPE,
      orderTypes.EDGING,
      orderTypes.EDGING_COMPLETION,
    ].includes(nextType)
    const willBeFrame = orderTypes.WITH_FRAME === nextType

    // if we pick shape and have frame --> reset
    if (willBeShape && this.props.fields.frame.value) {
      this.props.fields.$setValue('frame', null)
      this.props.selectVca()
    }
    // if we pick frame and dont have frame --> reset
    if (willBeFrame && !this.props.fields.frame.value) {
      this.props.fields.$setValue('frame', null)
      this.props.selectVca()
    }
  }

  onChangeActionsR = affectsLensList => this.onLensPropsChange(R, affectsLensList)

  onChangeActionsL = affectsLensList => this.onLensPropsChange(L, affectsLensList)

  onFieldBlur = e => {
    this.validateNextSteps()
    // manually trigger, what we overwrote
    this.props.fields.$handleBlur(e)
  }

  handleToggleSideEnabled = (e, side) => {
    const { fields, clearCurrentLens } = this.props
    const lensField = side === R ? fields.rightLensEnabled : fields.leftLensEnabled
    const otherLensField = side === R ? fields.leftLensEnabled : fields.rightLensEnabled

    if (!e.checked && !otherLensField.value) return
    lensField.onChange(e)

    if (!appTypeConfig.areBothLensesAlwaysSame) {
      fields.isLeftLensSameAsRight.onChange({ value: false })
    } else if (side === L && e.checked) {
      // we cannot easily detect if other lens is available, so we just clear everything
      // it should not happen very often
      clearLensFieldsValues({ fields, side: R })
      clearCurrentLens(R)
      clearLensFieldsValues({ fields, side: L })
      clearCurrentLens(L)
    }
  }

  handleLeftLensEnabledChange = e => {
    this.handleToggleSideEnabled(e, L)
  }

  handleRightLensEnabledChange = e => {
    this.handleToggleSideEnabled(e, R)
  }

  getOnFieldBlur = name => () => this.onFieldBlur({ name })

  getWorkersOptions = memoize(
    workers =>
      workers &&
      workers.length > 0 &&
      workers.map(w => ({
        text: w.name,
        value: w._id,
      })),
  )
  // TODO: pridat memoize na options

  render() {
    const {
      fields,
      lensR,
      lensL,
      wantCalculation,
      workers,
      t,
      isReferenceUnique,
      notifs,
      currentOrder,
      currentOrderPlaceholder,
      currentFirstPair,
    } = this.props
    const lensParamsFieldsConfig = {
      rightDisabled: !fields.rightLensEnabled.value,
      leftDisabled: !fields.leftLensEnabled.value,
      onChangeActionsR: this.onChangeActionsR,
      onChangeActionsL: this.onChangeActionsL,
      // some fields may be higher than others because of long titles
      // this will make sure the field group is not unnecessary high when it is closed
      hiddenMaxHeight: '153px',
    }

    // co když bude jen jedna z čoček mít degresi?
    const hasLensWithDegression = lensR?.withDegression || lensL?.withDegression

    const fieldsValues = fields.$values()
    const { orderType } = fieldsValues

    // inject to every field
    Object.keys(fields).forEach(k => {
      if (k.startsWith('$')) {
        return
      }
      fields[k].onBlur = this.getOnFieldBlur(k)
    })

    const isSphOrCylInHundredths = isSphOrCylFieldInHundredths(fields)

    const warningsObject = getOrderFormWarnings(fields.$values())

    const copyMiLensIdToClipboard = () => {
      copy(fieldsValues.miLensId)
      notifs.success({ title: t('Fusion data ID copied to clipboard!') })
    }

    return (
      <div>
        <Box>
          <Box.Header>
            <Box.Title>{t('order specification')}</Box.Title>
          </Box.Header>
          <Box.Content>
            <Row alignItems="flex-end">
              <Col data-id="orderTypeSelect">
                <OrderTypeField
                  {...fields.orderType}
                  onChange={e => {
                    this.clearFrameOrShape(e)
                    fields.orderType.onChange(e)
                    this.onLensPropsChange(R, true)
                    this.onLensPropsChange(L, true)
                  }}
                  fields={fields}
                />
              </Col>
              {workers && workers.length > 0 && (
                <>
                  <Gap />
                  <Col width="20rem">
                    <SelectField
                      label={t('who is filling order')}
                      options={this.getWorkersOptions(workers)}
                      {...fields.worker}
                    />
                  </Col>
                </>
              )}

              {fields.$values().firstPair && (
                <>
                  <Gap />
                  <Col justifyContent="flex-end">
                    <PopTooltip
                      text={
                        currentFirstPair?.reference
                          ? `${t('First pair reference')}: ${currentFirstPair?.reference}`
                          : null
                      }
                    >
                      <InfoMessage>{t('this is second pair')}</InfoMessage>
                    </PopTooltip>
                  </Col>
                </>
              )}

              {fields.$values().miLensId && (
                <>
                  <Gap />
                  <Col justifyContent="flex-end" shrink="100">
                    <Row.Modern alignItems="center">
                      <PopTooltip text={fields.$values().miLensId}>
                        <div onClick={copyMiLensIdToClipboard}>
                          <InfoMessage>
                            {t('This order has MiLens measurement attached')}.
                          </InfoMessage>
                        </div>
                      </PopTooltip>
                      <PopTooltip
                        text={`${t('omega; Copy to clipboard')}: ${fields.$values().miLensId}`}
                      >
                        <div onClick={copyMiLensIdToClipboard}>
                          <Icon name="MdCopy" size={20} color="grey" />
                        </div>
                      </PopTooltip>
                    </Row.Modern>
                  </Col>
                </>
              )}
              {/* currentOrderPlaceholder is not cleaned after copy, which we want in this case */}
              {currentOrderPlaceholder?.survey?.variant && (
                <>
                  <Col>
                    <InfoMessage>
                      {t(`jaikudo: order based on ${currentOrderPlaceholder?.survey?.variant}`)}
                    </InfoMessage>
                    <Gap gap="0.4rem" />
                  </Col>
                </>
              )}
            </Row>
            <Row alignItems="flex-end">
              <Col width="25%">
                <ReferenceField {...fields.reference} />
              </Col>
              <Col width="25%">
                <TextField
                  label={t('client name')}
                  tooltip={t('STEP_1_CLIENT_NAME_DESCRIPTION')}
                  maxLength={fieldsConfig.clientName.maxLength}
                  {...fields.clientName}
                />
              </Col>
              {appTypeConfig.isInternalNoteEnabled !== false && (
                <Col width="50%">
                  <TextField label={t('internal remark')} {...fields.internalNote} />
                </Col>
              )}
            </Row>
            {!isReferenceUnique && <WarningMessage>{t('Reference is not unique')}</WarningMessage>}
          </Box.Content>
        </Box>
        <Box>
          <Box.Header>
            <Box.Title>{t('clients credentials')}</Box.Title>
          </Box.Header>
          <Box.Content>
            <Row alignItems="flex-start" flexWrap={fieldsValues.isEdgingWithoutShape ? 'wrap' : ''}>
              <SelectRL justifyContent="flex-end" compact>
                <SelectRightWrapper justifyContent="center">
                  <CheckboxField
                    label={t('R')}
                    labelPosition="left"
                    {...fields.rightLensEnabled}
                    onChange={this.handleRightLensEnabledChange}
                  />
                </SelectRightWrapper>
                <SelectLeftWrapper justifyContent="center">
                  <CheckboxField
                    label={t('L')}
                    labelPosition="left"
                    {...fields.leftLensEnabled}
                    onChange={this.handleLeftLensEnabledChange}
                  />
                </SelectLeftWrapper>
              </SelectRL>
              <Col compact>
                <LensParamsField
                  title={t('refraction')}
                  isDefaultOpen
                  {...lensParamsFieldsConfig}
                  style={{ marginBottom: fieldsValues.isEdgingWithoutShape ? '1rem' : '' }}
                  options={[
                    {
                      label: t('sphere'),
                      required: true,
                      affectsLensList: true,
                      showSign: true,
                      ...getBothLensFields(fields, lensFields.sphere),
                    },
                    {
                      label: t('cylinder'),
                      affectsLensList: true,
                      showSign: true,
                      ...getBothLensFields(fields, lensFields.cylinder),
                    },
                    {
                      label: t('axis'),
                      ...getBothLensFields(fields, lensFields.axis),
                    },
                    {
                      label: hasLensWithDegression ? t('degression') : t('addition'),
                      affectsLensList: true,
                      ...getBothLensFields(fields, lensFields.addition),
                    },
                  ]}
                />
              </Col>
              {showCentration(fieldsValues) && (
                <Col compact>
                  <LensParamsField
                    title={t('centration')}
                    isDefaultOpen
                    {...lensParamsFieldsConfig}
                    options={[
                      {
                        label: t('pd'),
                        required: true,
                        ...getBothLensFields(fields, lensFields.pd),
                      },
                      {
                        label: t('height'),
                        required: true,
                        ...getBothLensFields(fields, lensFields.height),
                      },
                    ]}
                  />
                </Col>
              )}
              <Col compact>
                <LensParamsField
                  title={t('prism')}
                  {...lensParamsFieldsConfig}
                  options={[
                    {
                      label: t('prism1'),
                      affectsLensList: true,
                      ...getBothLensFields(fields, lensFields.prism1),
                    },
                    {
                      label: t('base1'),
                      ...getBothLensFields(fields, lensFields.base1),
                    },
                    {
                      label: t('prism2'),
                      affectsLensList: true,
                      ...getBothLensFields(fields, lensFields.prism2),
                    },
                    {
                      label: t('base2'),
                      ...getBothLensFields(fields, lensFields.base2),
                    },
                  ]}
                />
              </Col>
              {showDecentration(fields.orderType.value) && (
                <Col compact>
                  <LensParamsField
                    title={t('decentration')}
                    {...lensParamsFieldsConfig}
                    options={[
                      {
                        label: t('decX'),
                        ...getBothLensFields(fields, lensFields.decX),
                      },
                      {
                        label: t('decY'),
                        ...getBothLensFields(fields, lensFields.decY),
                      },
                    ]}
                  />
                </Col>
              )}
              {showMinimalThickness(fields.orderType.value) && (
                <Col compact>
                  <LensParamsField
                    title={t('minimal thickness')}
                    {...lensParamsFieldsConfig}
                    options={[
                      {
                        label: t('edge'),
                        ...getBothLensFields(fields, lensFields.minEdgeThickness),
                        disabledR: !!fields.minCenterThicknessR.value,
                        disabledL: !!fields.minCenterThicknessL.value,
                      },
                      appTypeConfig.isCenterThicknessEnabled && {
                        label: t('center'),
                        ...getBothLensFields(fields, lensFields.minCenterThickness),
                        disabledR: !!fields.minEdgeThicknessR.value,
                        disabledL: !!fields.minEdgeThicknessL.value,
                      },
                    ].filter(a => a)}
                  />
                </Col>
              )}
              {appTypeConfig.isLensBaseEnabled && (
                <Col compact>
                  <LensParamsField
                    title={t('base')}
                    // v originale baseCurve
                    {...lensParamsFieldsConfig}
                    options={[
                      {
                        label: t('lens base'),
                        ...getBothLensFields(fields, lensFields.baseCurve),
                      },
                    ]}
                  />
                </Col>
              )}
            </Row>
            {isSphOrCylInHundredths && appTypeConfig.isSphAndCylInHundredthsEnabled && (
              <WarningMessage>
                {t('reize; WARNING MESSAGE - sphere and cylinder in hundredths')}
              </WarningMessage>
            )}
            {warningsObject.shouldShowSphereWarning && 
              <WarningMessage>{t(warningsObject.sphereWarning)}</WarningMessage>
            }
            {warningsObject.shouldShowCylinderWarning && 
              <WarningMessage>{t(warningsObject.cylinderWarning)}</WarningMessage>
            }
            {warningsObject.shouldShowDifferentAdditionWarning && 
              <WarningMessage>{t(warningsObject.differentAdditionWarning)}</WarningMessage>
            }
          </Box.Content>
        </Box>
        <Box>
          <Box.Header>
            <Box.Title>{t('lens type select')}</Box.Title>
          </Box.Header>
          <Box.Content>
            <Row alignItems="flex-start">
              <Col width="50%">
                {fields.rightLensEnabled.value && (
                  <LensTypeSection
                    fields={fields}
                    label={t('right lens')}
                    side={R}
                    lensFields={lensFields}
                    fetchLensesActions={this.fetchLensesActionsNextFrame}
                    selectedLensName={lensR && lensR.names && lensR.names[0].long}
                  />
                )}
              </Col>
              <Col width="50%">
                {fields.leftLensEnabled.value && (
                  <LensTypeSection
                    fields={fields}
                    label={t('left lens')}
                    side={L}
                    lensFields={lensFields}
                    fetchLensesActions={this.fetchLensesActionsNextFrame}
                    showIsLeftSameAsRight={fields.rightLensEnabled.value}
                    selectedLensName={lensL && lensL.names && lensL.names[0].long}
                  />
                )}
              </Col>
            </Row>
            <Row>
              {warningsObject.shouldShowDifferentLensesWarning && 
                <WarningMessage>{t(warningsObject.lensWaning)}</WarningMessage>
              }
            </Row>
          </Box.Content>
        </Box>
        {fieldsValues.isEdgingWithoutShape && <Row>
          <Col width="50%">
            <FrameTypeBox fields={fields} />
          </Col>
        </Row>}
        <Row>
          {this.getIsIndividualMenuAvailable() && (
            <Col width="62%">
              <IndividualSection fields={fields} />
            </Col>
          )}
          {appTypeConfig.isNoteEnabled !== false && (
            <Col grow="1">
              <NoteSection fields={fields} />
            </Col>
          )}
        </Row>
        <CreateOrderButtonsWrapper justifyContent="flex-end">
          {/* <Col>
            <Button large onClick={fields.$reset}>RESET FIELDS</Button>
          </Col> */}
          <Col>
            <Button.TrashOrder fields={fields} />
          </Col>
          <Col>
            <Button.SaveConcept fields={fields} />
          </Col>
          {orderType === orderTypes.DIAMETER_ONLY && !wantCalculation && (
            <Col>
              <Button.Step3
                orange
                onClick={() => this.validateFieldsAndRedirect(LinkButton.CREATE_ORDER_STEP_3)}
              />
            </Col>
          )}
          <Col width="10rem" />
          <Col alignItems="flex-end">
            <Row>
              {orderType !== orderTypes.DIAMETER_ONLY && (
                <Button.Step2
                  orange
                  onClick={() => this.validateFieldsAndRedirect(LinkButton.CREATE_ORDER_STEP_2)}
                />
              )}
              {orderType === orderTypes.DIAMETER_ONLY && (
                <>
                  {wantCalculation && (
                    <>
                      <Button.Step3
                        onClick={() =>
                          this.validateFieldsAndRedirect(LinkButton.CREATE_ORDER_STEP_3)
                        }
                      />
                      <Gap />
                      <Button.Step4
                        double
                        onClick={() =>
                          this.validateFieldsAndRedirect(LinkButton.CREATE_ORDER_STEP_4)
                        }
                      />
                    </>
                  )}
                  {!wantCalculation && (
                    <Button.Step4
                      onClick={() => {
                        this.validateFieldsAndRedirect(LinkButton.CREATE_ORDER_STEP_4)
                      }}
                    />
                  )}
                </>
              )}
            </Row>
          </Col>
        </CreateOrderButtonsWrapper>
        {/* <button onClick={() => { notifyWarning('this is warning') }}>testttt</button> */}
      </div>
    )
  }
}

OrderStep1Form.defaultProps = {
  lensesList: [],
  shouldUpdateLensesListR: false,
  shouldUpdateLensesListL: false,
  lensR: null,
  lensL: null,
  canSelectStockLensR: true,
  canSelectStockLensL: true,
  isReferenceUnique: true,
  isLoading: false,
}

OrderStep1Form.propTypes = {
  fields: PropTypes.object.isRequired,
  fetchLensSelectList: PropTypes.func.isRequired,
  lensesList: PropTypes.array,
  shouldUpdateLensesListR: PropTypes.bool,
  shouldUpdateLensesListL: PropTypes.bool,
  setShouldUpdateLensesList: PropTypes.func.isRequired,
  clearCurrentLens: PropTypes.func.isRequired,
  enableOrderStep: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  notifs: PropTypes.object.isRequired,
  wantCalculation: PropTypes.bool.isRequired,
  lensR: PropTypes.object,
  lensL: PropTypes.object,
  setCanSelectStockLens: PropTypes.func.isRequired,
  canSelectStockLensR: PropTypes.bool,
  canSelectStockLensL: PropTypes.bool,
  validateLensParams: PropTypes.func.isRequired,
  fetchWorkers: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  validatingParamsL: PropTypes.bool.isRequired,
  validatingParamsR: PropTypes.bool.isRequired,
  workers: PropTypes.array.isRequired,
  fetchLens: PropTypes.func.isRequired,
  selectVca: PropTypes.func.isRequired,
  isReferenceUnique: PropTypes.bool,
  isLoading: PropTypes.bool,
}

const enhance = compose(
  withRouter,
  connect(
    ({ catalog, orders, config, vca, app }) => ({
      shouldUpdateLensesListR: catalog.shouldUpdateLensesListR,
      shouldUpdateLensesListL: catalog.shouldUpdateLensesListL,
      lensR: catalog.currentLensR,
      lensL: catalog.currentLensL,
      currentOrder: orders.currentOrder,
      wantCalculation: vca.wantCalculation,
      canSelectStockLensR: catalog.canSelectStockLensR,
      canSelectStockLensL: catalog.canSelectStockLensL,
      validatingParamsL: catalog.validatingParamsL,
      validatingParamsR: catalog.validatingParamsR,
      workers: app.workers,
      isReferenceUnique: orders.isReferenceUnique,
      currentOrderPlaceholder: orders.currentOrderPlaceholder,
      currentFirstPair: orders.currentFirstPair,
    }),
    {
      fetchLensSelectList,
      fetchCatalogExtensions,
      fetchFrameBrands,
      setShouldUpdateLensesList,
      clearCurrentLens,
      enableOrderStep,
      setCanSelectStockLens,
      validateLensParams,
      fetchWorkers,
      fetchLens,
      selectVca,
    },
  ),
  withNotifs,
  withTranslation(),
)

export default enhance(OrderStep1Form)
